<div class="position-relative">
  <a (click)="onPopupClose()" class="close mat-modal-close"><i class="material-icons">close</i></a>
  <mat-tab-group animationDuration="0ms" dynamicHeight [(selectedIndex)]="TabIndex" (selectedTabChange)="changeTab($event)" class="mat-tab-secondary">
    <mat-tab label="List">
      <ng-template matTabContent>
        <div class="align-items-center">
          <div class="search-input pl-2 mb-2">
            <input type="text" type="search" [(ngModel)]="SearchValue" maxlength="200" (keyup.backspace)="OnBlankInput($event)" class="form-control field-search W-98" placeholder="Press ENTER to search" name="search2" (keyup.enter)="onSearch()" (input)="onInputChange($event)">
          </div>
        </div>
        <div [ngClass]="{'paddingMax' : this.showloader}">
        <app-page-tiny-loader *ngIf="this.showloader" (loaderClosed)="onLoaderClosed()"></app-page-tiny-loader>
      </div>
        <div class="table-responsive table-sticky" *ngIf="!this.showloader">
          <table class="table table-default table-hover">
            <thead>
              <tr>
                <th>Country</th>
                <th>State</th>
                <th>City</th>
                <th>Zip Code</th>
                <th>Address Line 1</th>
                <th>Address Line 2</th>
                <th>Location Code</th>
                <th>Location Name</th>
                <th>Description</th>
                <th class="text-right">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let loc of LocationListData; let i = index;">
                <td>
                  <a style="cursor: pointer;" role="button" href="javascript:void(0);" (click)="Select(loc)">
                    {{ loc?.state?.country?.countryName }}
                  </a>
                </td>
                <td><span>{{ loc?.state?.stateName }}</span></td>
                <td><span>{{ loc?.city }}</span></td>
                <td><span>{{ loc?.zipCode }}</span></td>
                <td>
                  <span matTooltip="{{ loc?.addressLine1 }}">
                    {{ loc?.addressLine1?.length > 20 ? loc?.addressLine1.substring(0, 20) + '...' : loc?.addressLine1 }}
                  </span>
                </td>
                <td>
                  <span matTooltip="{{ loc?.addressLine2 }}">
                    {{ loc?.addressLine2?.length > 20 ? loc?.addressLine2.substring(0, 20) + '...' : loc?.addressLine2 }}
                  </span>
                </td>
                <td><span>{{ loc?.locationCode }}</span></td>
                <td>
                  <span matTooltip="{{ loc?.locationName }}">
                    {{ loc?.locationName?.length > 20 ? loc?.locationName.substring(0, 20) + '...' : loc?.locationName }}
                  </span>
                </td>
                <td>
                  <span matTooltip="{{ loc?.description }}">
                    {{ loc?.description?.length > 20 ? loc?.description.substring(0, 20) + '...' : loc?.description }}
                  </span>
                </td>
                <td class="text-right">
                  <div class="d-flex align-items-center justify-content-end">
                    <span class="material-icons text-primary material-md-icon pointer" matTooltip="Edit" (click)="Edit(loc)">edit</span>
                    <span class="material-icons closeicon pointer material-md-icon ml-2" matTooltip="Delete" (click)="clickMethod(loc)">close</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="nofoundTxt" colspan="10" *ngIf="LocationListData.length < 1">
                  <h1><i class="far fa-frown mr-1"></i>&nbsp;No data found!</h1>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <mat-paginator #paginator *ngIf="LocationListData?.length > 0" [showFirstLastButtons]="true" [length]="Paginator.Length"
          [pageSize]="Paginator.PageSize" [pageSizeOptions]="Paginator.PageSizeOptions" (page)="setPagination($event)">
        </mat-paginator>
      </ng-template>
    </mat-tab>

    <mat-tab label="{{ Operation }}">
      <ng-template matTabContent>
        <div class="p-3">
          <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-md-6">
                <label>Location Code</label>
                <mat-form-field appearance="outline" class="w-100 material-readonly">
                  <input matInput type="text" id="LocationCode" placeholder="Auto generated" formControlName="locationCode"
                    (keypress)="removeSpaces($event)" (keypress)="omitValidateSpecialChar($event)" readonly name="locationCode"
                    maxlength="50">
                </mat-form-field>
                <!-- <div class="errorMsg ErrorMsgSetting" *ngIf="formGroup.get('locationCode')?.errors && Submitted">
                  <span *ngIf="formGroup.get('locationCode')?.errors?.['required']">Location Code is required</span>
                </div> -->
              </div>
              <div class="col-md-6">
                <label>Location Name <span class="req">*</span></label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput type="text" id="LocationName" placeholder="Enter Location Name" formControlName="locationName" name="locationName"
                    (keypress)="removeSpaces($event)" (keypress)="omitValidateSpecialChar($event)"
                    maxlength="100" required>
                </mat-form-field>
                <div class="errorMsg ErrorMsgSetting" *ngIf="formGroup.get('locationName')?.errors && Submitted">
                  <span *ngIf="formGroup.get('locationName')?.errors?.['required']">Location Name is required</span>
                </div>
              </div>

              <div class="col-md-3" style="display: none;">
                <label>County</label>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select formControlName="county">
                    <mat-option value="" disabled selected="selected">Select County</mat-option>
                    <mat-option *ngFor="let county of counties" [value]="county.countyId">
                      {{ county.countyName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <label>Address Line-1</label>
                <mat-form-field appearance="outline" class="w-100">
                  <textarea matInput id="AddressLine1" placeholder="Enter Address Line-1" formControlName="addressLine1"
                    (keypress)="removeSpaces($event)" (keypress)="omitValidateSpecialChar($event)" (paste)="handlePaste($event)"
                    cdkAutosizeMinRows="3" class="field-control resizeno" maxlength="150"></textarea>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <label>Address Line 2</label>
                <mat-form-field appearance="outline" class="w-100">
                  <textarea matInput id="addressLine2" placeholder="Enter Address Line-2" formControlName="addressLine2"
                    (keypress)="removeSpaces($event)" (keypress)="omitValidateSpecialChar($event)" (paste)="handlePaste($event)"
                    cdkAutosizeMinRows="3" class="field-control resizeno" maxlength="150"></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <label>Country <span class="req">*</span></label>
                <mat-form-field appearance="outline" class="w-100">
                  <input type="text" id="DDcountry" placeholder="Type/Select Country" formControlName="countryId" matInput
                    [matAutocomplete]="auto4" required [ngClass]="{ 'is-invalid': formGroup.get('countryId')?.errors }"
                    (input)="filterCountry($event)" class="field-control">
                  <mat-autocomplete #auto4="matAutocomplete" (closed)="handleClosed(countries,originalCountryList, formGroup, 'countryId', 'countryName')"  #countryauto="matAutocomplete"
                  (optionSelected)="onSelectionCallback($event, formGroup, 'countryId', 'countryName')" [displayWith]="displayCountry">
                    <mat-option *ngFor="let x of countries" [value]="x">
                      {{ x.countryName }}
                    </mat-option>
                    <mat-option *ngIf="countries?.length === 0" disabled class="no-data-option">
                      Country Not Found!
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <div class="errorMsgMT ErrorMsgSetting" *ngIf="formGroup.get('countryId')?.errors && Submitted">
                  <span *ngIf="formGroup.get('countryId')?.errors?.['required']">Country is required</span>
                </div>
                <!-- <small *ngIf="countries?.length == 0 &&  formGroup.get('countryName')?.value?.length > 0" class="no-data-text">{{ConstantNoData}}</small> -->
              </div>

              <div class="col-md-3">
                <label>State <span class="req">*</span>
                  <small class="loaderFile" *ngIf="StateLoader">
                    <img src="/assets/images/preloader.gif" style="height: 18px;width: auto; display: inline-block; margin-bottom: -3px;" />
                    Loading states...
                  </small>
                </label>
                <mat-form-field appearance="outline" class="w-100" [ngClass]="{'material-readonly': !formGroup.get('countryId')?.value}">
                  <input type="text" id="stateName" placeholder="Type/Select State" formControlName="stateId" matInput
                    [matAutocomplete]="auto5" required [ngClass]="{ 'is-invalid': formGroup.get('stateId')?.errors}"
                    (input)="filterState($event)" [readonly]="!formGroup.get('countryId')?.value" class="field-control">
                  <mat-autocomplete #auto5="matAutocomplete" (closed)="handleStateClosed(States,originalstateList, formGroup, 'stateId', 'stateName')"
                  (optionSelected)="onSelectionCallback($event, formGroup, 'state', 'stateName')" [displayWith]="displayState">
                    <mat-option *ngFor="let x of States" [value]="x">
                      {{ x.stateName }}
                    </mat-option>
                    <mat-option *ngIf="!StateLoader && States?.length === 0" disabled class="no-data-option">
                      State Not Found!
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <!-- <small *ngIf="States?.length == 0 &&  formGroup.get('stateName')?.value?.length > 0" class="no-data-text">{{ConstantNoData}}</small> -->
                <div class="errorMsgMT ErrorMsgSetting" *ngIf="formGroup.get('stateId')?.errors && Submitted">
                  <span *ngIf=" formGroup.get('stateId')?.errors?.['required']">State is required</span>
                </div>
              </div>

              <div class="col-md-3">
                <label>City <span class="req">*</span>
                  <small class="loaderFile" *ngIf="CityLoader">
                    <img src="/assets/images/preloader.gif" style="height: 18px;width: auto; display: inline-block; margin-bottom: -3px;" />
                    Loading cities...
                  </small>
                </label>

                <mat-form-field appearance="outline" class="w-100" [ngClass]="{'material-readonly': !formGroup.get('stateId')?.value}" >
                  <input type="text" id="cityName" placeholder="Type/Select City" formControlName="city" matInput
                    [matAutocomplete]="auto6" required [ngClass]="{ 'is-invalid': formGroup.get('city')?.errors}"
                    (input)="filterCity($event)" class="field-control" [readonly]="!formGroup.get('stateId')?.value">
                  <mat-autocomplete #auto6="matAutocomplete" (closed)="onClosedCallback(City,originalcityList, formGroup, 'city', 'cityName')"
                  (optionSelected)="onSelectionCallback($event, formGroup, 'city', 'cityName')"
                  [displayWith]="displayCity">
                    <mat-option *ngFor="let x of City"  [value]="x">
                      {{ x.cityName }}
                    </mat-option>
                    <mat-option *ngIf="!CityLoader && City?.length === 0" disabled class="no-data-option">
                      City Not Found!
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <!-- <small *ngIf="City?.length == 0 &&  formGroup.get('city')?.value?.length > 0" class="no-data-text">{{ConstantNoData}}</small> -->
                <div class="errorMsgMT ErrorMsgSetting" *ngIf="formGroup.get('city')?.errors && Submitted">
                  <span *ngIf="formGroup.get('city')?.errors?.['required']">City is required</span>
                </div>
              </div>

              <div class="col-md-3">
                <label>Zip Code <span class="req">*</span></label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput type="text" id="ZipCode" placeholder="Enter Zip Code" formControlName="zipCode"
                    (keydown.space)="$event.preventDefault()" (keypress)="restrictInput($event)" pattern="^[a-zA-Z0-9]+$"
                    class="field-control" minlength="5" maxlength="10" required (paste)="handleZipCodePaste($event)">
                </mat-form-field>
                <div class="errorMsg ErrorMsgSetting" *ngIf="formGroup.get('zipCode')?.invalid && Submitted">
                  <div *ngIf="formGroup.get('zipCode')?.errors?.['required']">Zip Code is required</div>
                  <div *ngIf="formGroup.get('zipCode')?.errors?.['minlength']">Zip Code should be at least 5 digits</div>
                  <div *ngIf="formGroup.get('zipCode')?.errors?.['maxlength']">Zip Code should be a maximum of 10 digits</div>
                  <div *ngIf="formGroup.get('zipCode')?.errors?.['pattern']">Only alphanumeric allowed.</div>
                </div>
              </div>

              <div class="col-md-6">
                <label>Longitude</label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput type="text" id="Longitude" placeholder="Enter Longitude" formControlName="longitude" onkeypress="if ( isNaN(this.value + String.fromCharCode(event.keyCode) )) return false;"
                    class="field-control" maxlength="20" [ngClass]="{ 'is-invalid': formGroup.get('longitude')?.invalid && (formGroup.get('longitude')?.touched || Submitted) }" (paste)="preventNonNumericPaste($event)">
                </mat-form-field>
                <div class="errorMsg ErrorMsgSetting" *ngIf="formGroup.get('longitude')?.hasError('invalidDecimal') && (formGroup.get('longitude')?.touched || Submitted)">
                  Invalid Longitude format. Please ensure it's in the correct decimal format.
                </div>
              </div>

              <div class="col-md-6">
                <label>Latitude</label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput type="text" id="Latitude" placeholder="Enter Latitude" formControlName="latitude" onkeypress="if ( isNaN(this.value + String.fromCharCode(event.keyCode) )) return false;"
                    class="field-control" maxlength="20" [ngClass]="{ 'is-invalid': formGroup.get('latitude')?.invalid && (formGroup.get('latitude')?.touched || Submitted) }" (paste)="preventNonNumericPaste($event)">
                </mat-form-field>
                <div class="errorMsg ErrorMsgSetting" *ngIf="formGroup.get('latitude')?.hasError('invalidDecimal') && (formGroup.get('latitude')?.touched || Submitted)">
                  Invalid Latitude format. Please ensure it's in the correct decimal format.
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <label>Description</label>
                <mat-form-field appearance="outline" class="w-100">
                  <textarea matInput id="Description" placeholder="Enter Description" formControlName="description"
                    (keypress)="removeSpaces($event)"
                    cdkAutosizeMinRows="3" class="field-control resizeno" maxlength="255"></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="ml-auto text-right">
              <button type="button" class="btn btn-secondary mr-2" (click)="gotoBack()">Back</button>
              <button type="submit" class="btn btn-primary">{{ Operation }}</button>
            </div>
          </form>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
